import { Component, Inject } from '@angular/core';
import { Product } from '../../Model/product';
import { WebOrderDeliveryTimeSlotSetup } from '../../Model/web-order-delivery-time-slot-setup';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastService } from '../../services/toast.service';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonExternalModule } from '../../common/common-external-module';

@Component({
  selector: 'app-delivery-time-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, CommonExternalModule],
  templateUrl: './delivery-time-dialog.component.html',
  styleUrl: './delivery-time-dialog.component.css'
})
export class DeliveryTimeDialogComponent {

  product: Product = new Product();
  webOrderDeliveryTimeSlotSetup: WebOrderDeliveryTimeSlotSetup[] = [];

  constructor(
    public dialogRef: MatDialogRef<DeliveryTimeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private toastService: ToastService,
  ) {
    if (dialogData && dialogData.product)
      this.product = dialogData.product;
    if (dialogData && dialogData.deliveryTimeSlotSetup)
      this.dateChanged()
  }

  ngOnInit(): void {
  }

  dateChanged() {
    this.product.deliveryDate = this.product.deliveryDate ? moment(this.product.deliveryDate).format("YYYY-MM-DD") : null;
    if (this.product.defaultDate == this.product.deliveryDate) {
      this.webOrderDeliveryTimeSlotSetup = this.dialogData.deliveryTimeSlotSetup.filter(e => this.product.defaultTimeSlotAvl.includes(e.timeSlot));
    }
    else {
      this.webOrderDeliveryTimeSlotSetup = this.dialogData.deliveryTimeSlotSetup;
    }

    if (!this.webOrderDeliveryTimeSlotSetup.some(e => e.timeSlot == this.product.deliveryTime)) {
      this.product.deliveryTime = this.webOrderDeliveryTimeSlotSetup[0]?.timeSlot;
    }

  }

  onConfirmClick() {
    this.product.deliveryDate = moment(this.product.deliveryDate).format("YYYY-MM-DD");
    if (this.product.deliveryTime) {
      this.dialogRef.close({ data: this.product });
    }
    else {
      this.toastService.showErrorToast('Choose Delivery Slot');
    }
  }

}
